import { URLs } from '.'
import { Theme } from '../data/models/funnelOrder/theme'
import * as pages from '../pages'

export const funnelUrls: URLs = {
  solotogether: {
    urls: {
      nl: '/solo-together',
      be: '/solo-together',
    },
    component: pages.Solo,
    theme: Theme.solo,
  },
  ezy: {
    urls: {
      default: '/ezy',
    },
    component: pages.Ezy,
  },
  tube: {
    urls: {
      uk: '/tube',
    },
    component: pages.Tube,
  },
  flycustomise: {
    urls: {
      default: '/fly/customise-trip',
      nl: '/vliegreis/samenstellen',
      be: '/vliegreis/samenstellen',
      de: '/flugreise/zusammenstellen',
      dk: '/flyve/sammensaet-rejse',
    },
    component: pages.Customise,
    theme: Theme.fly,
  },
  drivecustomise: {
    urls: {
      default: '/autoreis/customise-trip',
      nl: '/autoreis/samenstellen',
      be: '/autoreis/samenstellen',
      dk: '/autoreis/sammensaet-rejse',
    },
    component: pages.DriveCustomise,
    theme: Theme.drive,
  },
  multiflycustomise: {
    urls: {
      nl: '/vliegreis/meederesteden/samenstellen',
      be: '/vliegreis/meederesteden/samenstellen',
    },
    component: pages.MulitCustomise,
    theme: Theme.multiFly,
  },
  multidrivecustomise: {
    urls: {
      nl: '/autoreis/meederebestemmingen/samenstellen',
      be: '/autoreis/meederebestemmingen/samenstellen',
    },
    component: pages.MultiDrive,
    theme: Theme.multiDrive,
  },
  solocustomise: {
    urls: {
      nl: '/solo-together/samenstellen',
      be: '/solo-together/samenstellen',
      de: '/solo-together/zusammenstellen',
    },
    component: pages.SoloCustomise,
    theme: Theme.solo,
  },

  flyextras: {
    urls: {
      default: '/fly/add-extras',
      nl: '/vliegreis/extras-bijboeken',
      be: '/vliegreis/extras-bijboeken',
      de: '/vlugreise/extras-bijboeken',
      dk: '/fly/tilvalg',
    },
    component: pages.Extras,
    theme: Theme.fly,
  },
  driveextras: {
    urls: {
      default: '/drive/add-extras',
      nl: '/autoreis/extras-bijboeken',
      be: '/autoreis/extras-bijboeken',
      de: '/autofahrt/extras-bijboeken',
      dk: '/koerselv/tilvalg',
    },
    component: pages.Extras,
    theme: Theme.drive,
  },
  multiflyextras: {
    urls: {
      nl: '/vliegreis/meederesteden/extras-bijboeken',
      be: '/vliegreis/meederesteden/extras-bijboeken',
    },
    component: pages.Extras,
    theme: Theme.multiFly,
  },
  multidriveextras: {
    urls: {
      nl: '/autoreis/meederebestemmingen/extras-bijboeken',
      be: '/autoreis/meederebestemmingen/extras-bijboeken',
    },
    component: pages.Extras,
    theme: Theme.multiDrive,
  },
  soloextras: {
    urls: {
      default: '/solo-together/add-extras',
      nl: '/solo-together/extras-bijboeken',
      be: '/solo-together/extras-bijboeken',
    },
    component: pages.Extras,
    theme: Theme.solo,
  },
  incontrolextras: {
    urls: {
      nl: '/in-control/extras-bijboeken',
      be: '/in-control/extras-bijboeken',
    },
    component: pages.Extras,
    theme: Theme.incontrol,
  },

  flydetails: {
    urls: {
      default: '/fly/traveldetails',
      nl: '/vliegreis/reisgegevens',
      be: '/vliegreis/reisgegevens',
      de: '/vlugreise/reisedaten',
      dk: '/fly/rejseinformationer',
    },
    component: pages.Details,
    theme: Theme.fly,
  },
  drivedetails: {
    urls: {
      default: '/drive/traveldetails',
      nl: '/autoreis/reisgegevens',
      be: '/autoreis/reisgegevens',
      de: '/autofahrt/reisdaten',
      dk: '/koerselv/rejseinformationer',
    },
    component: pages.Details,
    theme: Theme.drive,
  },
  multiflydetails: {
    urls: {
      nl: '/vliegreis/meedersteden/reisgegevens',
      be: '/vliegreis/meedersteden/reisgegevens',
    },
    component: pages.Details,
    theme: Theme.multiFly,
  },
  multidrivedetails: {
    urls: {
      nl: '/autoreis/meederebestemmingen/reisgegevens',
      be: '/autoreis/meederebestemmingen/reisgegevens',
    },
    component: pages.Details,
    theme: Theme.multiDrive,
  },
  solodetails: {
    urls: {
      default: '/solo-together/traveldetails',
      nl: '/solo-together/reisgegevens',
      be: '/solo-together/reisgegevens',
      de: '/solo-together/reisdaten',
    },
    component: pages.Details,
    theme: Theme.solo,
  },
  incontroldetails: {
    urls: {
      nl: '/in-control/reisgegevens',
      be: '/in-control/reisgegevens',
      dk: '/in-control/rejseinformationer',
    },
    component: pages.Details,
    theme: Theme.incontrol,
  },

  confirm: {
    urls: {
      default: '/trip-summary',
      nl: '/reissamenstelling-controleren',
      be: '/reissamenstelling-controleren',
      dk: '/rejseoversigt',
    },
    component: pages.Confirm,
    funnel: true,
  },

  entryPage: {
    urls: {
      default: '/srprs-trip/:code',
      nl: '/verrassingsreis/:code',
      be: '/verrassingsreis/:code',
      dk: '/srprs-trip/:code',
    },
    component: pages.EntryPage,
  },
  entryextras: {
    urls: {
      default: '/srprs-trip/:code/extras',
      nl: '/verrassingsreis/:code/extras',
      be: '/verrassingsreis/:code/extras',
      dk: '/srprs-trip/:code/tilvalg',
    },
    component: pages.Extras,
    stopReset: true,
  },
  entrydetails: {
    urls: {
      nl: '/verrassingsreis/:code/reisgegevens',
      be: '/verrassingsreis/:code/reisgegevens',
      uk: '/srprs-trip/:code/details',
      ie: '/srprs-trip/:code/details',
      dk: '/srprs-trip/:code/detaljer',
    },
    component: pages.Details,
    stopReset: true,
  },
}

export const pageNames = Object.keys(funnelUrls)
